import env from '../../../env'

// The local monolith stack (docker Hasura, `mix phx.server`) only speaks plain HTTP.
// Plain text is opt-in (REACT_APP_LOCAL_MONOLITH=true), only under the dev server
// (`yarn start`; every `yarn build` is NODE_ENV=production, `yarn test` is test), and only
// for exact loopback hostnames, so a look-alike host such as `localhost.example.com` or a
// forgotten env var still gets TLS.
const LOOPBACK_HOSTNAMES = ['localhost', '127.0.0.1', '[::1]']

type Options = { nodeEnv?: string; localMonolith?: boolean }

const defaults: Options = {
  nodeEnv: process.env.NODE_ENV,
  localMonolith: env.LOCAL_MONOLITH
}

const isLoopback = (host: string) => {
  try {
    return LOOPBACK_HOSTNAMES.includes(new URL(`http://${host}`).hostname)
  } catch (e) {
    return false
  }
}

const allowsPlainText = (host: string, { nodeEnv, localMonolith }: Options) =>
  nodeEnv === 'development' && localMonolith === true && isLoopback(host)

export const httpUrl = (host: string, path: string, options = defaults) =>
  `${allowsPlainText(host, options) ? 'http' : 'https'}://${host}${path}`

export const wsUrl = (host: string, path: string, options = defaults) =>
  `${allowsPlainText(host, options) ? 'ws' : 'wss'}://${host}${path}`
